module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"filter":"фильтр","Net Worth":"Всего денег","monthly":"/мес","of income":"от доходов"},"en":{"monthly":"/mo"}}')
  delete Component.options._Ctor
}
